import React, { useEffect, useState } from 'react';
import { Activity } from 'lucide-react';
import api from '../lib/api';

export const ActivityCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/api/usage/summary').then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const t = data.totals || {};
  const f = data.features || {};
  const secs = t.total_duration_seconds || 0;
  const hrs = Math.floor(secs / 3600);
  const mins = Math.round((secs % 3600) / 60);
  const stats = [
    { label: 'Days active', value: t.days_active || 0 },
    { label: 'Time on platform', value: hrs ? `${hrs}h ${mins}m` : `${mins}m` },
    { label: 'Sessions', value: t.sessions || 0 },
    { label: 'Exams completed', value: f.exams_completed || 0 },
    { label: 'Course minutes', value: Math.round(f.course_minutes || 0) },
    { label: 'CRS reports', value: f.crs_reports || 0 },
  ];
  return (
    <div className="bg-white rounded-2xl border border-slate-100 p-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]" data-testid="dashboard-activity-card">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0"><Activity size={18} /></div>
        <div>
          <h3 className="font-[Manrope] font-bold text-slate-900">Your Activity</h3>
          <p className="text-xs text-slate-500">
            {t.last_seen ? `Last active ${new Date(t.last_seen).toLocaleString()}` : 'Your usage will appear here as you study'}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {stats.map((s) => (
          <div key={s.label} className="bg-slate-50 rounded-xl p-3 text-center" data-testid={`activity-stat-${s.label.toLowerCase().replace(/ /g, '-')}`}>
            <div className="text-lg font-bold text-slate-900">{s.value}</div>
            <div className="text-[11px] text-slate-500 leading-tight mt-0.5">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityCard;
